import { render, staticRenderFns } from "./costRegisterManger.vue?vue&type=template&id=10c5897e&scoped=true"
import script from "./costRegisterManger.vue?vue&type=script&lang=js"
export * from "./costRegisterManger.vue?vue&type=script&lang=js"
import style0 from "./costRegisterManger.vue?vue&type=style&index=0&id=10c5897e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c5897e",
  null
  
)

export default component.exports